import React from 'react';

// const Buttonbar = (props) => (
//   <nav className='flex ml-0 md:ml-9 lg:ml-9 xl:ml-9'>
//     <a
//       className={
//         props.viewType === 'week'
//           ? 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border rounded-l border-green-gray hover:text-summary-header text-summary-header bg-green'
//           : 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border rounded-l border-green-gray hover:text-summary-header text-summary-header'
//       }
//       set-key='7_days'
//       onClick={() => props.onChangePeriod('week')}
//     >
//       {props.t('7_days')}
//     </a>
//     <a
//       className={
//         props.viewType === 'month'
//           ? 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border-t border-b border-r border-green-gray hover:text-summary-header text-summary-header bg-green'
//           : 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border-t border-b border-r border-green-gray hover:text-summary-header text-summary-header'
//       }
//       set-key='4_weeks'
//       onClick={() => props.onChangePeriod('month')}
//     >
//       {props.t('4_weeks')}
//     </a>
//     <a
//       className={
//         props.viewType === 'year'
//           ? 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border-t border-b border-green-gray hover:text-summary-header text-summary-header bg-green'
//           : 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border-t border-b border-green-gray hover:text-summary-header text-summary-header'
//       }
//       set-key='1_year'
//       onClick={() => props.onChangePeriod('year')}
//     >
//       {props.t('1_year')}
//     </a>
//     <a
//       className={
//         props.viewType === '10year'
//           ? 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border rounded-r border-green-gray hover:text-summary-header text-summary-header bg-green'
//           : 'flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border rounded-r border-green-gray hover:text-summary-header text-summary-header'
//       }
//       set-key='10_years'
//       onClick={() => props.onChangePeriod('10year')}
//     >
//       {props.t('10_years')}
//     </a>
//   </nav>
// );

const Buttonbar = (props) => {
  const getButtonClass = (viewType) => 
    `flex items-center justify-center w-30 h-9 text-lg font-normal tracking-wide text-center no-underline capitalize border 
    ${viewType === props.viewType ? 'text-summary-header bg-green' : 'text-summary-header'} 
    ${viewType === 'week' ? 'rounded-l' : viewType === '10year' ? 'rounded-r' : 'border-t border-b border-r'} 
    border-green-gray hover:text-summary-header`;

  const buttons = [
    { key: '7_days', label: '7_days', viewType: 'week' },
    { key: '4_weeks', label: '4_weeks', viewType: 'month' },
    { key: '1_year', label: '1_year', viewType: 'year' },
    { key: '10_years', label: '10_years', viewType: '10year' }
  ];

  return (
    <nav className='flex ml-0 md:ml-9 lg:ml-9 xl:ml-9'>
      {buttons.map(({ key, label, viewType }) => (
        // eslint-disable-next-line
        <a
          key={key}
          className={getButtonClass(viewType)}
          onClick={() => props.onChangePeriod(viewType)}
        >
          {props.t(label)}
        </a>
      ))}
    </nav>
  );
};

export default Buttonbar;
